<style>
  .layout.row {
    margin-bottom: 20px!important;
  }
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">KPI статьи</h3>
          <v-btn
                  color="pink"
                  dark
                  small
                  fab
                  @click="editOpen()"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
                  color="blue"
                  dark
                  small
                  fab
                  @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Поиск"
                      v-model="search"
                      hide-details
                      class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                      :headers="complex.headers"
                      :search="search"
                      :items="kpiArticleData"
                      :rows-per-page-items="[10,25,50,100]"
                      class="elevation-1"
                      item-key="kpiId"
                      no-results-text="Нет результатов"
                      rows-per-page-text="На странице"
                      v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">

                  <td>{{ props.item.kpiId }}</td>
                  <td>{{ props.item.kpiKey }}</td>
                  <td>{{ props.item.kpiTitle }}</td>
                  <td>{{ props.item.ordering }}</td>
                  <td>
                    <span
                            v-for="period in periodData"
                            v-bind:data="period"
                            v-bind:key="period.value"
                            v-if="props.item.kpiPeriod.indexOf(period.value) != -1"
                    >
                      <v-avatar>
                        <v-icon>calendar_today</v-icon>
                      </v-avatar>
                      {{ period.text }}
                    </span>
                  </td>
                  <td>
                    <v-chip
                          v-for="role in roleData"
                          v-bind:data="role"
                          v-bind:key="role.value"
                          v-if="props.item.roleKey.indexOf(role.value) != -1"
                          :class="getRoleColor(role.value)"
                          text-color="white"
                    >
                      <v-avatar>
                        <v-icon>account_circle</v-icon>
                      </v-avatar>
                      {{ role.text }}
                    </v-chip>
                  </td>
                  <td>

                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>

                  </td>
                </template>



              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Роль</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select
                                    v-model.lazy="modalData.roleKey"
                                    :items="roleData"
                                    attach
                                    chips
                                    deletable-chips
                                    label="Роль"
                                    multiple
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID KPI</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="ID KPI"
                                    v-model="modalData.kpiId"
                                    readonly
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Внешний ключ KPI</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <span v-if="readonlyFields">{{modalData.kpiKey}}</span>
                            <v-text-field
                                    v-if="!readonlyFields"
                                    label="Внешний ключ KPI"
                                    v-model="modalData.kpiKey"
                                    :rules="rules.kpiKey"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Наименование KPI</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="Наименование KPI"
                                    v-model="modalData.kpiTitle"
                                    :rules="rules.required"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Период действия</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select
                                    v-model.lazy="modalData.kpiPeriod"
                                    :items="periodData"
                                    attach
                                    chips
                                    deletable-chips
                                    label="Период действия"
                                    multiple
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Сортировка</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="Сортировка"
                                    v-model="modalData.ordering"
                                    :rules="rules.ordering"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить KPI?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<style>
  .role-object-row {
    padding: 10px;
    border: 1px solid #aaaaaa;
    text-align: center;
    font-size: 16px;
    color: #878686;
    margin-bottom: -1px;
    cursor: pointer;
    background: #f1f0f0;
  }
  .active {
    background: #ffffff;
  }
</style>

<script>

    export default {
        components: {
        },
        data () {
            return {
                modalData: {},
                oldModalData: {},
                editedIndex: {},
                valid: true,
                readonlyFields: true,
                openColorBox: false,
                isEdit: false,
                rules: {
                    required: [ v => !!v || 'Обязательное поле' ],
                    kpiKey: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
                        v => this.kpiArticleData.filter(el => el.kpiKey === v).length === 0 || 'Такой ключ уже существует',
                    ],
                    ordering: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => this.kpiArticleData.filter(el => parseInt(el.ordering) === parseInt(v) && parseInt(el.kpiId) !== parseInt(this.modalData.kpiId)).length === 0 || 'Такая сортировка уже существует',
                        v => !!parseInt(v) || 'Можно использовать только числа'
                    ]
                },
                search: '',
                popupRemove: {
                    isOpen: false
                },
                popupEdit: {
                    isOpen: false,
                    isEditing: false,
                },
                complex: {
                    selected: [],
                    headers: [
                        {
                            text: 'ID KPI',
                            value: 'kpiId'
                        },
                        {
                            text: 'Внешний ключ',
                            value: 'kpiKey'
                        },
                        {
                            text: 'Наименование KPI',
                            value: 'kpiTitle'
                        },
                        {
                            text: 'Сортировка',
                            value: 'ordering'
                        },
                        {
                            text: 'Период действия',
                            value: 'kpiPeriod'
                        },
                        {
                            text: 'Роль',
                            value: 'roleKey'
                        },
                        {
                            text: 'Действия',
                            value: ''
                        }
                    ],
                },
                periodData: [
                    {
                        value: '1',
                        text: '2018-2019'
                    },
                    {
                        value: '49',
                        text: '2019-2020'
                    },
                    {
                        value: '54',
                        text: '2020-2021'
                    },
                    {
                        value: '59',
                        text: '2021-2022'
                    },
                    {
                        value: '64',
                        text: '2022-2023'
                    },
                    {
                        value: '69',
                        text: '2023-2024'
                    },
                    {
                        value: '74',
                        text: '2024-2025'
                    },
                    {
                        value: '79',
                        text: '2025-2026'
                    },
                    {
                        value: '84',
                        text: '2026-2027'
                    },
                    {
                        value: '89',
                        text: '2027-2028'
                    },
                    {
                        value: '94',
                        text: '2028-2029'
                    },
                ],
            };
        },
        mounted: function () {
            /**
             * Загружаем данные по ролям при первой отрисовке страницы, если roleData не пустой, то не обновляемся
             */
            if (this.kpiArticleData.length === 0)
            {
                this.refresh();
            }

            /**
             * Загружаем данные по ролям, если roleData не пустой, то не обновляемся
             */
            if (this.$store.getters['role/roleData'].length === 0)
            {
                this.$store._actions['role/getRoleData'][0]();
            }

            /**
             * Загружаем данные по уровням управления, если levelData не пустой, то не обновляемся
             */
            if (this.$store.getters['level/levelData'].length === 0)
            {
                this.$store._actions['level/getLevelData'][0]();
            }

        },

        computed: {

            /**
             * Данные по статьям KPI
             * @returns {default.computed.kpiArticleData|(function())|Array|getters.kpiArticleData}
             */
            kpiArticleData () {
                return this.$store.getters['kpi/kpiArticleData']
            },

            /**
             * Данные по ролям
             * @returns {default.computed.roleData|(function())|Array|getters.roleData}
             */
            roleData () {
                return this.$store.getters['role/roleData'].map(item => {
                    return { text: item.roleTitle, value: item.roleKey }
                })
            },
        },

        methods: {

            /**
             * Обновление данных по ролям
             */
            refresh () {
                this.$store._actions['kpi/getKpiArticleData'][0]();
            },

            /**
             * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
             * @param item
             */
            editOpen (item) {
                // Если редактирование
                if (item !== null && typeof (item) !== 'undefined') {
                    this.modalData = item;
                    this.isEdit = true;
                    this.oldModalData = Object.assign({}, item);
                    this.editedIndex = this.kpiArticleData.indexOf(item);
                    this.readonlyFields = true;
                // Если добавление
                } else {
                    this.modalData = {
                        kpiId: -1,
                        kpiKey: '',
                        kpiTitle: '',
                        ordering: '',
                        roleKey: [],
                    };
                    this.isEdit = false;
                    this.oldModalData = {};
                    this.editedIndex = -1;
                    this.readonlyFields = false;
                }
                this.popupEdit.isOpen = true;
            },

            /**
             * Отмена редактирования
             */
            editCancel () {
                if (this.editedIndex != -1) {
                    Object.assign(this.kpiArticleData[this.editedIndex], this.oldModalData);
                }
                this.popupEdit.isOpen = false;
            },

            /**
             * Сохранение отредактированного элемента
             */
            submit () {
                if (this.$refs.form.validate()) {
                    this.$store._actions['kpi/saveKpiArticleData'][0]({index: this.editedIndex, data: this.modalData}).then(() => {
                        this.popupEdit.isOpen = false;
                    })
                }
            },

            /**
             * Открытие модального окна с подтверждением удаления
             * @param data
             */
            removeItemConfirm (data) {
                this.popupRemove.isOpen = true;
                this.modalData = data;
            },

            /**
             * Удаление элемента
             * @param item
             */
            actionRemove (item) {
                this.$store._actions['kpi/removeKpiArticleData'][0]({item: item});
                this.popupRemove.isOpen = false;
            },

            /**
             * Получение цвета "чипсов" роли в таблице
             * @param roleKey
             * @returns {*}
             */
            getRoleColor (roleKey) {
                return this.$store.getters['role/roleData'].filter(item => {
                    return item.roleKey === roleKey;
                })[0].roleColor;
            }
        }
    };
</script>

<style>
  .v-chip__content{
    cursor: pointer!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ui/KPI.vue